import { createSelector } from 'reselect';
import { RootState } from 'src/state/RootState';

export const getUrlQueryString = createSelector([
    (state: RootState) => state.router.location.search,
], (query) => new URLSearchParams(query));
